import { useFetch } from 'hooks/use-fetch/use-fetch';
import { IPagination } from 'hooks/use-table/use-table.props';
import { useQuery } from '@tanstack/react-query';
import { PolicyQueryKeys } from '../policy.props';
import { PolicyCompanyList, PolicyCompanyListResponse } from './company-list.props';
import { ApiResponse, ResponseModel } from 'common/interfaces';
import { carPolicyRequestConfig } from '../../../../request-config/car-policy/car-policy.request-config';
import { RequestStatuses } from '@/constants';

const modifyResponse = ({ data }: ApiResponse<PolicyCompanyListResponse>): PolicyCompanyList => {
  if (data.level === RequestStatuses.Success) {
    const formattedPolicy = data.data.items.map(policy => {
      return {
        modifiedon: policy.modifiedon.attributeValue,
        uds_carpolicyid: policy.uds_carpolicyid.attributeValue,
        uds_name: policy.uds_name.attributeValue,
        uds_type: policy.uds_type.attributeValue?.value || null,
        items: policy.items.map(item => {
          return {
            id: item.uds_carpolicyitemid.attributeValue,
            label: item.uds_name.attributeValue
          };
        })
      };
    });
    return {
      ...data.data,
      items: formattedPolicy
    };
  }

  return defaultQuery;
};

export const usePolicyCompanyListQuery = (
  pagination: IPagination | {},
  enabled: boolean = true,
  isShowLoading: boolean = true
) => {
  const { fetch } = useFetch<ResponseModel<PolicyCompanyListResponse>>({
    loadingKey: `policyCompanyList${JSON.stringify(pagination)}`,
    isShowLoading,
    ...carPolicyRequestConfig.companyList(pagination)
  });

  const { data, isLoading } = useQuery<ApiResponse<PolicyCompanyListResponse>, unknown, PolicyCompanyList>({
    queryKey: [PolicyQueryKeys.CompanyList, pagination],
    queryFn: () => fetch(),
    select: modifyResponse,
    enabled
  });

  return { policyCompanyListQuery: data || defaultQuery, isLoading };
};

const defaultQuery: PolicyCompanyList = {
  items: [],
  totalCount: 0
};
